$component-class: 'sn-reviews';

.#{$component-class} {
  &__image-col {
    display: none;

    @include above($breakpoint-desktop-md) {
      display: block;
    }
  }

  &__image {
    overflow: hidden;
    border-radius: var(--radius-size-lg);
    background-color: #ffe6dd; // TODO: no exact token

    me-picture,
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    @include above($breakpoint-desktop-md) {
      aspect-ratio: 1 / 1;
    }
  }

  &__carousel {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xl);

    @include above($breakpoint-desktop-md) {
      position: relative;
      gap: var(--spacing-2xl);
      padding-left: var(--spacing-3xl);
    }
  }

  &__card {
    background-color: var(--background-color-secondary);
    border-radius: var(--radius-size-lg);
    padding: map-get($spacings, xl);
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);

    @include above($breakpoint-desktop-md) {
      background-color: transparent;
      border-radius: 0;
      padding: 0;
      gap: map-get($spacings, xl);
    }
  }

  &__slides-author {
    position: relative;
    flex: 1;
    min-height: 64px;

    @include above($breakpoint-desktop-md) {
      padding-right: 120px;
    }
  }

  &__author-slide {
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    will-change: opacity;

    &--active {
      opacity: 1;
      position: relative;
      z-index: 1;
    }

    &--hidden {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;
      z-index: 0;
    }
  }

  &__arrows {
    display: flex;
    justify-content: center;
    gap: var(--spacing-md);

    @include above($breakpoint-desktop-md) {
      position: absolute;
      top: 0;
      right: 0;
      height: 64px;
      align-items: center;
      justify-content: flex-end;
    }
  }

  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 50%;
    transition: opacity 0.2s ease;

    @include above($breakpoint-desktop-md) {
      width: 48px;
      height: 48px;
    }

    &:hover {
      opacity: 0.7;
    }

    &:focus-visible {
      outline: 2px solid var(--action-color-brand-primary);
      outline-offset: 2px;
    }

    svg {
      display: block;
      flex-shrink: 0;
    }
  }

  &__slides {
    position: relative;
    min-height: 200px;
  }

  &__slide {
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    will-change: opacity;

    &--active {
      opacity: 1;
      position: relative;
      z-index: 1;
    }

    &--hidden {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;
      z-index: 0;
    }
  }

  &__author {
    display: flex;
    align-items: center;
    gap: var(--spacing-lg);
  }

  &__avatar {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid var(--color-neutral-white);
    background-color: #b1ceff; // TODO: no exact token

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__author-info {
    line-height: map-get($line-heights, 'md');
  }

  &__author-name {
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, bold);
    color: var(--color-neutral-black);

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, md);
    }
  }

  &__author-role {
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, regular);
    color: var(--color-neutral-black);
    display: block;

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, md);
    }
  }

  &__quote {
    margin: 0;
    padding: 0;
    border: none;

    p {
      font-size: map-get($font-sizes, xl);
      line-height: map-get($line-heights, lg);
      color: var(--color-neutral-black);
      margin: 0;

      @include above($breakpoint-desktop-md) {
        font-size: 26px;
        line-height: 40px;
      }

      strong {
        font-weight: map-get($font-weights, 'bold');
      }
    }
  }
}
